<div class="btn-group" role="group">
    @for (option of optionEntries; track option) {
    <input type="radio"
           class="btn-check"
           [name]="groupName"
           [id]="option.id"
           autocomplete="off"
           [checked]="selectedValue === option.value"
           (change)="onValueChange(option.value)"
           [value]="option.value"
           [disabled]="isDisabled" />
    <label class="btn btn-outline-primary" [for]="option.id">
        {{
            option.label
        }}
    </label>
    }
</div>
